import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { checkRequiredFields } from './validateFields';

const FormButton = ({ children, requiredFields, submittedFields, reqLength = 1 }) => {
  return (
    <Form.Group controlId="formSubmit">
      <Button
        variant="occu-primary"
        type="submit"
        block
        disabled={!checkRequiredFields(requiredFields, submittedFields, reqLength)}
      >
        {children || 'Submit'}
      </Button>
    </Form.Group>
  );
};

export { FormButton };
